/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Topics_EmptyInputs */



/**
* | output |
* | --- |
* | "Not judged yet" |
*
* @param {Meeting_Topics_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_topics_empty = /** @type {((inputs?: Meeting_Topics_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Topics_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog niet beoordeeld")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore évalué")
	return /** @type {LocalizedString} */ ("Not judged yet")
});